import { MONEY_DECIMALS, roundMoney } from 'shared-models/browser';

export { MONEY_DECIMALS, roundMoney };

export function formatMoney(value: number): string {
  return roundMoney(value).toFixed(MONEY_DECIMALS);
}

/** Like formatMoney but drops the decimal when it's .0 (e.g. 5.0 → "5", 5.5 → "5.5") */
export function formatMoneyCompact(value: number): string {
  const fixed = roundMoney(value).toFixed(MONEY_DECIMALS);
  return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
}

const LTR_ISOLATE = '\u2066';
const POP_DIRECTIONAL_ISOLATE = '\u2069';

// Wrap a negative amount in an LTR isolate so the minus stays left of the digits in RTL (bidi fix).
export function isolateAmountLtr(formatted: string): string {
  return formatted.startsWith('-') ? `${LTR_ISOLATE}${formatted}${POP_DIRECTIONAL_ISOLATE}` : formatted;
}
